













































import { UiConfirm } from '../keen-ui';
import ActionsBar from './actions-bar.component.vue';
import PaginationBar from './pagination-bar.component.vue';

export default {
  name: 'crud-list',
  components: {
    ActionsBar,
    PaginationBar,
    UiConfirm
  },
  props: {
    query: String,
    selection: Array,
    permissions: {
      type: Object,
      default: () => ({
        create: true,
        update: true,
        delete: true
      })
    },
    dataTitle: String,
    searchBoxAvailable: {
      type: Boolean,
      default: true
    },
    enableActionsAvailable: Boolean,
    forceOnlyOneItemEnabled: Boolean,
    forceOnlyOneItemEditable: {
      type: Boolean,
      default: true
    },
    pagination: Object,
    itemsPerPageOptions: Array,
    messages: Object
  },
  methods: {
    onEnable: function (): void {
      if (this.forceOnlyOneItemEnabled) {
        this.$refs.enableDialog.open();
      } else {
        this.$emit('setEnabled', true);
      }
    }
  }
};

